import { render, staticRenderFns } from "./coursePartner.vue?vue&type=template&id=79303eef&scoped=true"
import script from "./coursePartner.vue?vue&type=script&lang=js"
export * from "./coursePartner.vue?vue&type=script&lang=js"
import style0 from "./coursePartner.vue?vue&type=style&index=0&id=79303eef&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79303eef",
  null
  
)

export default component.exports